<template lang="pug">
  .procurement-aut-sfs-quotation(v-loading="loading")
    title-bar {{ $t('审核方案报价') }}
    h3(style="margin-left: 20px") {{ data.sub_final_scope_name }}
    template(v-if="tableData.length === 0")
      span(style="color:#808080") {{ $t('抱歉，没有您要找的供应商') }}!
    template(v-if='tableData[0]')
      audit-sub-item-content(
        v-for="(item, i) in tableData"
        :data="item"
        :key="'table_data' + i"
        :parentIndex="i"
        :index="0"
        @update="getApproveHistory",
        @clear="activeVendorIndex = -1"
      )
    title-bar {{ $t('确定方案报价') }}
    .description(v-if='isNeedIT && !isBypass')
      template(v-if="isView")
        el-row
          el-col(:span="4") {{ $t('审核结果') }}
          el-col(:span="8")
            span {{ auditResult.status === 1 ? $t('通过') : $t('拒绝') }}
        el-row
          el-col(:span="4") {{ $t('备注') }}
          el-col(:span="8")
            span {{ log.sub_final_scope_vendor_choice_advice.remark ? $t(log.sub_final_scope_vendor_choice_advice.remark) : $t('一') }}
      template(v-else)
        el-row
          el-col.required(:span="4") {{ $t('审核结果') }}
          el-col(
            :span="20"
          )
            el-radio-group(v-model="approve_result")
              el-radio(
                :disabled="isView"
                :label="1"
              ) {{ $t('通过') }}
              el-radio(
                :label="2"
                :disabled="isView"
              ) {{ $t('拒绝') }}
        el-row
          el-col(
            :span="4"
          )
            span {{ $t('备注') }}
          el-col(
            :span="20"
          )
            el-input(
              v-model="remark"
              type="textarea"
              :rows="8"
              style="width: 380px"
              :placeholder="$t('不多于500字')"
              v-validate="'max:500'"
              name="remark"
            )
    .vendor-radio(v-else)
      template(v-if="!isBypass")
        template(v-if='isView')
          el-row
            el-col(:span="4") {{ $t('供应商') }}
            el-col(:span="8") {{log.vendor_name_ch}}/{{log.vendor_name}}
          el-row
            el-col(
              :span="4"
            )
              span {{ $t('备注') }}
            el-col(
              :span="20"
            )
              span {{log.remark ? $t(log.remark) : $t('一')}}
        template(v-if="!isView")
          select-vendor-radio(
            :required="true"
            :data="tableData"
            @onChange="(val) => activeVendorIndex = val"
            :defaultIndex="activeVendorIndex"
          )
          el-row
            el-col(
              :span="4"
            )
              span {{ $t('备注') }}
            el-col(
              :span="20"
            )
              el-input(
                v-model="remark"
                type="textarea"
                :rows="8"
                style="width: 380px"
                :placeholder="$t('不多于500字')"
                v-validate="'max:500'"
                name="remark"
              )
    template(v-if="isView")
      template(v-if="isBypass")
        el-row
          el-col(:span="4") Total Saving Cost
          el-col(:span="12") {{ log.total_saving_lost | formatMoney  }}
        el-row
          el-col(
            :span="4"
          )
            span {{ $t('备注') }}
          el-col(
            :span="20"
          )
            span {{log.remark ? $t(log.remark) : $t('一')}}
      el-row
        el-col(
          :span="4"
        ) {{ $t('是否需要第三方材料说明') }}
        el-col(
          :span="20"
          v-if='isBypass || !isNeedIT'
        ) {{log.is_need_thirdparty_material === 1 ? $t('是') : $t('否')}}
        el-col(
          :span="20"
          v-else
        ) {{log.sub_final_scope_vendor_choice_advice.is_need_thirdparty_material?$t('是'):$t('否')}}
      el-row(v-if='log.is_need_thirdparty_material === 1 || (log.sub_final_scope_vendor_choice_advice && log.sub_final_scope_vendor_choice_advice.is_need_thirdparty_material)')
        el-col(
          :span="4"
        ) {{ $t('第三方材料说明') }}
        el-col(
          :span="20"
          v-if='isBypass || !isNeedIT'
        ) {{log.material?log.material:$t('一')}}
        el-col(
          :span="20"
          v-else
        ) {{log.sub_final_scope_vendor_choice_advice.material?log.sub_final_scope_vendor_choice_advice.material:$t('一')}}

    template(v-else)
      template(v-if="isBypass")
        el-row
          el-col.required(
            :span="4"
          ) {{ $t('Total Saving Lost ') }}
          el-col(
            :span="20"
          )
            vue-numeric(
              style="width: 180px"
              v-model="total_saving_lost"
              :unit="$t('元')"
              :precision="2"
            )
        el-row
          el-col(
            :span="4"
          )
            span {{ $t('备注') }}
          el-col(
            :span="20"
          )
            el-input(
              v-model="remark"
              type="textarea"
              :rows="8"
              style="width: 380px"
              :placeholder="$t('不多于500字')"
              v-validate="'max:500'"
              name="remark"
            )
      .description
        el-row
          el-col(
            :span="4"
          ) {{ $t('是否需要第三方材料') }}
          el-col(
            :span="20"
          )
            el-radio-group(v-model="descriptionFlag")
              el-radio(:label="1") {{ $t('是') }}
              el-radio(:label="0") {{ $t('否') }}
        el-row(v-if='descriptionFlag === 1')
          el-col(
            :span="4"
          )
            .required {{ $t('材料说明') }}
          el-col(
            :span="20"
          )
            el-input(
              v-model="description"
              type="textarea"
              :rows="8"
              style="width: 380px"
              :placeholder="$t('不多于500字')"
              v-validate="'max:500'"
              name="description"
            )
      .procurement-audit-sfs-quotation__buttons(v-if='isNeedIT && !isBypass')
        footer-button(
          :confirmButtonDisabled="approve_result === -1"
          :confirmButton="$t('完成')"
          :cancelButton="$t('返回')"
          @confirm="onConfirm"
          @cancel="onCancel"
        )
      .procurement-audit-sfs-quotation__buttons(v-else)
        footer-button(
          :confirmButtonDisabled="shouldDisabledBtn"
          :confirmButton="$t('完成')"
          :cancelButton="$t('返回')"
          @confirm="onConfirm"
          @cancel="onCancel"
        )
    template(v-if="versions.length !== 0")
      title-bar(style="margin-top: 32px") {{ $t('历史版本') }}
      div(style="padding: 0 20px;margin-bottom: 50px;margin-top:20px")
        template(v-for="item in versions")
          audit-versions-item(:item="item" :auditType="isBypass ? 31 : 5")
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import AuditVersionsItem from '@/components/AuditVersions/AuditVersionsItem'
import AuditSubItemContent from './AuditSubItemContent'
import { flatten } from 'lodash'
import MarketingAudit from '@/components/MarketingAudit'
import SelectVendorRadio from '@/components/SelectVendorRadio'
import { format4backend, formatMoney } from '@/umcc/util'
import db from '@/umcc/db'
import VueNumeric from '@/components/VueNumeric'

const getApproveHistory = (id, businessType, auditType) => {
  return axios.get('/management/subfinal/getApproveHistory', {
    params: {
      id: id,
      business_type: businessType,
      audit_type: auditType
    }
  })
}

export default {
  components: {
    TitleBar,
    FooterButton,
    AuditVersionsItem,
    AuditSubItemContent,
    MarketingAudit,
    SelectVendorRadio,
    VueNumeric
  },
  data () {
    return {
      tableData: [],
      versions: [],
      loading: false,
      // canUserEditCampaign: null,
      keyword: '',
      hasGetHistory: false,
      activeVendorIndex: -1,
      approve_result: -1,
      description: '',
      descriptionFlag: 0,
      auditResult: {},
      remark: '',
      data: {},
      log: {},
      total_saving_lost: null
    }
  },
  filters: {
    formatMoney
  },
  computed: {
    isNeedIT () {
      if (this.tableData[0]) {
        return !!this.tableData[0].category.find(item => { return item.category_id === 5 })
      } else {
        return false
      }
    },
    isZh () {
      return db.lang === 'zh'
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    taskId () {
      return this.$store.state.campaign.taskId
    },
    taskName () {
      return this.$store.state.campaign.taskName
    },
    businessType () {
      return this.$store.state.campaign.businessType
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    isBypass () {
      return this.$store.state.campaign.campaignSurvey.is_bypass === 1
    },
    shouldDisabledBtn () {
      return this.isBypass ? this.total_saving_lost == null : this.activeVendorIndex === -1
    }
  },
  mounted () {
    this.getApproveHistory()
    // this.checkCanUserEditCampaign()
  },
  methods: {
    // checkCanUserEditCampaign () {
    //   axios
    //     .get('/common/canEditCampaign', {
    //       params: {
    //         campaign_id: this.campaignId,
    //         task_name: this.taskName
    //       }
    //     })
    //     .then((res) => {
    //       this.canUserEditCampaign = res.can_edit
    //     })
    // },
    fetchTableData () {
      return axios
        .get('/management/subfinal/v3/getVendorProgressForQuotationExt', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
    },
    getApproveResult () {
      axios.get('/management/subfinal/getApproveResult', {
        params: {
          id: this.subFinalScopeId,
          business_type: this.businessType,
          audit_type: this.isBypass ? 31 : 17
        }
      })
        .then(res => {
          this.auditResult = res
        })
    },
    onConfirm () {
      if (!this.isBypass) {
        if (this.activeVendorIndex === -1 && !this.isNeedIT) {
          return
        }
        if (this.approve_result === -1 && this.isNeedIT) {
          return
        }
        if (this.descriptionFlag === 1 && (!this.description.length || this.description.length >= 500)) {
          this.$message.error(this.$t('请填写材料说明'))
          return
        }
      }
      this.$confirm(this.$t('提交后本页面信息将无法编辑，请确定是否提交'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          this.loading = true
          if (this.isNeedIT && !this.isBypass) {
            const params = {
              sub_final_scope_id: this.subFinalScopeId,
              task_id: this.taskId,
              approve_result: this.approve_result,
              servlet_path: this.$route.path,
              sub_final_scope_vendor_choice_advice: {
                remark: this.remark,
                is_need_thirdparty_material: this.descriptionFlag === 1 ? 1 : null,
                material: this.descriptionFlag === 1 ? this.description : null
              }
            }
            axios.get('/management/subfinal/v3/approveVendorPriceForPurchase?' + format4backend(params))
              .then(res => {
                this.loading = false
                this.$router.push('/campaign/process')
              })
          } else {
            const params = {
              sub_final_scope_id: this.subFinalScopeId,
              task_id: this.taskId,
              servlet_path: this.$route.path
            }
            let apiPath = ''
            if (this.isBypass) {
              apiPath = '/management/bypassCampaign/approveVendorPriceForPurchase'
              params.total_saving_lost = this.total_saving_lost
              params.remark = this.remark
              params.is_need_thirdparty_material = this.descriptionFlag === 1 ? 1 : 0
              params.material = this.descriptionFlag === 1 ? this.description : null
            } else {
              apiPath = '/management/subfinal/v3/adviceChoiceVendor'
              params.sub_final_scope_vendor_choice_advice = {
                remark: this.remark,
                vendor_id: this.activeVendorIndex,
                is_need_thirdparty_material: this.descriptionFlag === 1 ? 1 : 0,
                material: this.descriptionFlag === 1 ? this.description : null
              }
            }
            axios.post(apiPath, format4backend(params))
              .then(res => {
                this.loading = false
                if (this.isBypass && this.$store.state.campaign.campaignSurvey.has_io) {
                  this.$store.commit('campaign/setPhaseType', 3)
                }
                this.$router.push('/campaign/process')
              })
              .catch(err => {
                this.loading = false
                throw new Error(err)
              })
          }
        })
        .catch(() => {})
    },
    onCancel () {
      this.$router.push('/campaign/process')
    },
    getBusinessLog () {
      axios
        .get('/common/getBusinessLog', {
          params: {
            servlet_path: this.$route.path,
            business_key: this.subFinalScopeId
          }
        })
        .then(res => {
          this.log = res
        })
    },
    getSOWList () {
      return axios.get('/management/subfinal/getSubFinalScopeList', {
        params: {
          campaign_id: this.campaignId
        }
      })
        .then(res => {
          this.$store.commit('campaign/setSubFinalScopeId', res[0].sub_final_scope_id)
        })
    },
    async getApproveHistory () {
      this.loading = true
      if (this.isBypass) {
        await this.getSOWList()
      }
      if (this.isView) {
        this.getApproveResult()
        this.getBusinessLog()
      }
      const res = await this.fetchTableData()
      this.data = res
      this.tableData = res.sub_final_scope_vendor
      let tableDataVendors = this.tableData
      const arr = flatten(tableDataVendors)
      if (this.keyword !== '') {
        this.$store.commit('campaign/setQuotationExtendOrder', {
          '0': true,
          '0.0': false
        })
        const qeo = this.$store.state.campaign.quotationExtendOrder
        arr.forEach((v, i) => {
          this.$set(qeo, i, true)
        })
      }
      if (this.hasGetHistory) {
        this.loading = false
        return
      }

      Promise.all(arr.map(i => {
        return getApproveHistory(i.sub_final_scope_vendor_id, this.isBypass ? 17 : 4, this.isBypass ? 31 : 5)
      }))
        .then(res => {
          this.hasGetHistory = true
          this.versions = flatten(res)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  }

}
</script>

<style lang="stylus">
.procurement-aut-sfs-quotation
  .el-loading-mask
    margin -24px -32px
  .procurement-aut-sfs-quotation__title
    display flex
    align-items center
    justify-content space-between
    margin 3px 0 11px
    > span
      color $title-color
      font-size 16px
      font-weight 500
    .el-input
      width 200px
  .title-bar
    margin-bottom 0px
.procurement-audit-sfs-quotation__back-button
  margin-left 20px
.procurement-audit-sfs-quotation__buttons
  margin-top 24px
  display flex
  align-items center
  justify-content center
</style>
